export default __webpack_public_path__ + "static/media/default.1a3f2e43.png";